import { createFfTheme } from '@fraud-front/design-system';
import Link from 'next/link';

// Compatibility entry point while this app adopts the shared theme package.
// Keep frontend-only additions here rather than coupling the design system to
// Next.js.
export * from '@fraud-front/design-system';

export const ffTheme = createFfTheme({
  components: {
    MuiLink: {
      defaultProps: { component: Link }
    },
    MuiListItemButton: {
      defaultProps: { LinkComponent: Link }
    }
  }
});
